/* eslint-disable react/destructuring-assignment */
import React from 'react';
import classnames from 'classnames';
import styles from './styles.module.scss';

/** @import { SlotProps } from 'input-otp' /

/**
 * @param {SlotProps} props
 */
export function Slot(props) {
  return (
    <div
      className={classnames(styles.slot, {
        [styles.isActive ?? '']: props.isActive,
      })}
    >
      <div className={styles.innerSlot}>{props.char ?? props.placeholderChar}</div>
    </div>
  );
}
